import banner from "../../../courses/module-2/img8.png";

const modulo8 = {
  courseId: "cripto-blockchain",
  id: "modulo-8",
  title: "🧩 MÓDULO 8: Glosario y MiniConceptos Esenciales",
  estimatedDuration: "30 minutos",
  format: "Lectura + glosario + actividad de repaso",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivo del módulo",
      content: [
        "Este módulo está diseñado para ayudarte a repasar los conceptos esenciales que vimos a lo largo del curso. Aquí encontrarás definiciones, ejemplos reales, mini recordatorios y enlaces útiles para que puedas resolver cualquier duda y te prepares con confianza para la evaluación final.",
      ],
    },
    {
      id: "glosario",
      navLabel: "Glosario",
      title: "🧠 Glosario ampliado – Revisión general",
      content: [
        {
          type: "paragraph",
          text: "🔗 Blockchain",
        },
        {
          type: "list",
          items: [
            "Es un registro público, digital y descentralizado donde se almacenan todas las transacciones.",
            "Cada bloque contiene información y está conectado al anterior, formando una “cadena”.",
            "Ejemplo: Bitcoin y Ethereum usan blockchain para registrar quién tiene qué criptomoneda.",
          ],
        },
        {
          type: "paragraph",
          text: "💸 Criptomonedas",
        },
        {
          type: "list",
          items: [
            "Son monedas digitales que funcionan sin bancos ni gobiernos.",
            "Ejemplos: BTC (Bitcoin), ETH (Ethereum), SOL (Solana), ADA (Cardano), XLM (Stellar).",
            "Se usan para pagar, invertir o acceder a servicios digitales.",
          ],
        },
        {
          type: "paragraph",
          text: "🟡 Stablecoins",
        },
        {
          type: "list",
          items: [
            "Criptomonedas cuyo valor está vinculado a un activo estable, como el dólar.",
            "Ejemplos: USDT, USDC, DAI.",
            "Se usan para evitar la volatilidad de otras criptos.",
          ],
        },
        {
          type: "paragraph",
          text: "🌐 Web3",
        },
        {
          type: "list",
          items: [
            "La nueva versión de internet que pone el control en manos de los usuarios.",
            "Se basa en blockchain, descentralización y propiedad digital.",
            "Diferencias:",
          ],
        },
        {
          type: "orderedList",
          items: [
            "Web 1.0: solo leer",
            "Web 2.0: leer y escribir",
            "Web 3.0: leer, escribir y poseer",
          ],
        },
        {
          type: "paragraph",
          text: "🔐 Wallets (carteras digitales)",
        },
        {
          type: "list",
          items: [
            "Aplicaciones para almacenar y usar criptomonedas.",
            "Tipos:",
          ],
        },
        {
          type: "orderedList",
          items: [
            "Custodial (la plataforma guarda tus claves, ej. Binance)",
            "Non-custodial (tú tienes el control total, ej. Vesseo, MetaMask)",
          ],
        },
        {
          type: "list",
          items: [
            "Siempre respaldadas por una seed phrase (frase semilla) de seguridad.",
          ],
        },
        {
          type: "paragraph",
          text: "🔏 Seed Phrase",
        },
        {
          type: "list",
          items: [
            "Es tu llave maestra: una lista de 12 o 24 palabras que permiten recuperar tu wallet si pierdes tu dispositivo.",
            "Ejemplo: lluvia – tomate – tren – vacío – hoja…",
            "¡Nunca la compartas ni la guardes online!",
          ],
        },
        {
          type: "paragraph",
          text: "🔍 Exploradores blockchain",
        },
        {
          type: "list",
          items: [
            "Sitios donde puedes ver información pública de transacciones, bloques y wallets.",
            "Ejemplos:",
          ],
        },
        {
          type: "orderedList",
          items: ["Etherscan.io", "Solscan.io", "Stellar.expert"],
        },
        {
          type: "paragraph",
          text: "🛠️ Contratos inteligentes (Smart Contracts)",
        },
        {
          type: "list",
          items: [
            "Programas que se ejecutan automáticamente en la blockchain cuando se cumplen ciertas condiciones.",
            "Ejemplo: un contrato de préstamo que se paga automáticamente si depositas cierta cantidad de cripto.",
          ],
        },
        {
          type: "paragraph",
          text: "⚙️ Gas fees",
        },
        {
          type: "list",
          items: [
            "Comisiones pagadas para procesar una transacción en la blockchain.",
            "Algunas redes tienen comisiones altas (Ethereum), otras son más baratas (Stellar, Polygon).",
          ],
        },
        {
          type: "paragraph",
          text: "👤 KYC (Know Your Customer)",
        },
        {
          type: "list",
          items: [
            "Proceso obligatorio en muchas plataformas para verificar tu identidad.",
            "Ayuda a prevenir fraudes, pero también implica compartir tus datos personales.",
          ],
        },
        {
          type: "paragraph",
          text: "🔥 Términos clave en Web3",
        },
        {
          type: "table",
          headers: ["Término", "Definición breve"],
          rows: [
            ["DeFi", "Finanzas descentralizadas sin intermediarios"],
            [
              "NFT",
              "Token no fungible: arte digital, entradas, objetos únicos en blockchain",
            ],
            [
              "DAO",
              "Organización autónoma y descentralizada gobernada por sus miembros",
            ],
            [
              "Staking",
              "“Congelar” tus criptos para ayudar a una red y ganar recompensas",
            ],
            [
              "Airdrop",
              "Recompensa gratuita que se recibe por participar o registrarse en un proyecto",
            ],
            [
              "Farming",
              "Proveer liquidez a un protocolo DeFi a cambio de intereses",
            ],
            [
              "Token",
              "Representación digital de un activo o utilidad. Puede existir en varias redes",
            ],
          ],
        },
      ],
    },
    {
      id: "prevencion",
      navLabel: "Cómo evitar estafas",
      title: "⚠️ Cómo evitar estafas",
      content: [
        {
          type: "list",
          items: [
            "Verifica siempre la URL de los sitios donde conectas tu wallet.",
            "Nunca compartas tu seed phrase o claves privadas.",
            "Desconfía de promesas de dinero fácil o urgente.",
            "Usa plataformas confiables y revisa su historial.",
          ],
        },
      ],
    },
    {
      id: "extra",
      navLabel: "Nota extra",
      title: "📌 Nota extra: No confundas red, token y criptomoneda",
      content: [
        {
          type: "paragraph",
          text: "Una criptomoneda puede existir en más de una red.",
        },
        {
          type: "paragraph",
          text: "Ejemplo: USDC puede estar en Ethereum, Polygon, Solana y Stellar.",
        },
        {
          type: "paragraph",
          text: "Si envías por la red incorrecta, puedes perder tus fondos.",
        },
        {
          type: "paragraph",
          text: "✅ Antes de enviar:",
        },
        {
          type: "list",
          items: [
            "Verifica la red correcta (ERC-20, SPL, etc.)",
            "Asegúrate de que el receptor acepte esa red",
            "Confirma que el token sea compatible",
          ],
        },
      ],
    },
    {
      id: "lecturas",
      navLabel: "Recursos útiles",
      title: "📚 Recursos útiles",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/glossary",
          text: "Glosario Binance Academy",
        },
        {
          type: "link",
          href: "https://blog.telluscoop.com/p/stellarquest1",
          text: "Stellar Quest – Aprende y gana XLM",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad final",
      title: "✍ Actividad final del módulo",
      content: [
        "Crea en tu cuaderno un resumen con tus 10 conceptos favoritos de todo el curso.",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase del día",
      title: "🧠 Frase del día",
      content: [
        "“Dominar lo básico es lo que te permitirá ir lejos en el mundo cripto.”",
      ],
    },
  ],
};

export default modulo8;
